// import React, {useEffect, useMemo, useState} from 'react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

// import Page from 'Components/RoutingManager/Page';
// import LandingPage from 'Components/LandingPage/LandingPage';

import IVIATimer from 'Components/IVIATimer/IVIATimer';

const RoutingManager = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Page component={LandingPage} title="IVIA Timer" />} /> */}
      <Route path="/" element={<IVIATimer />} />
      <Route path="/timer" element={<IVIATimer />} />
    </Routes>
  );
};

export default RoutingManager;
